import { Select } from "components/inputs";
import { useEffect, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useGetServiceAssigneesQuery } from "services/service-assignee-api.ts";
import type { FileType, MiscServiceType } from "types/DataTypes";

import { ControlledDateInput } from "../../components/Card/ControlledInput";

const ConsultingAssignmentForm = ({
  service,
  file,
}: {
  service: MiscServiceType;
  file: FileType;
}) => {
  const {
    control,
    reset,
    formState: { errors },
  } = useFormContext();

  const { data: serviceAssignees = { results: [] } } =
    useGetServiceAssigneesQuery(
      {
        serviceId: service?.service?.id.toString(),
      },
      { skip: !service?.service },
    );

  useEffect(() => {
    reset({
      due_date: file?.due_date,
    });
  }, [reset, file]);

  const options = useMemo(() => {
    return serviceAssignees.results?.map(
      (assignee: { user_full_name: string; user: number; id: number }) => ({
        label: assignee.user_full_name,
        value: assignee.user,
        id: assignee.id,
      }),
    );
  }, [serviceAssignees]);

  return (
    <div className={`card form audit-and-consulting-card`}>
      <div className="card__header">Assignment</div>
      <div className="card__children">
        <Controller
          name="assignee"
          control={control}
          render={({ field: { name, onChange } }) => (
            <Select
              name={name}
              label="Assign Team Member"
              readOnly={true}
              value={options?.[0]}
              options={options}
              errors={errors}
              onChange={onChange}
            />
          )}
        />
        <ControlledDateInput
          control={control}
          label="Due Date"
          name="due_date"
          readOnly={true}
          errors={errors}
          onSave={() => new Promise((resolve) => resolve())}
        />
      </div>
    </div>
  );
};

export default ConsultingAssignmentForm;
